<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">{{ editMode ? "Edit advertisement banner" : "Create advertisement banner " }}</h3>
    </div>
  </div>
  <div class="p-4">
    <form *ngIf="manageAdvertisementBannerForm" [formGroup]="manageAdvertisementBannerForm" >
      <table formArrayName="advertisement_Banners" class="table mb-3">
        <tbody>
          <tr *ngFor="let advBanner of advertisementBanners.controls; let i = index;"
            class="row align-items-center mx-0 py-2" style="border-bottom: 3px solid #e43f52">
            <div class="col-md-10">
              <div class="row">
              <td class="col-md-12 mb-3" [formGroupName]="i">
                <app-image  [fieldObject]="advertisementBanner['image']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertAdvertisementBannersControls(i, 'image')" [isUpdate]="editMode" ></app-image>
              </td>
              <td class="col-md-4 mb-3" [formGroupName]="i">
                <app-text [fieldObject]="advertisementBanner['navigationLink']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertAdvertisementBannersControls(i, 'navigationLink')" [isUpdate]="editMode" ></app-text>
              </td>
              <td class="col-md-4 mb-3" [formGroupName]="i">
                <app-number [fieldObject]="advertisementBanner['order']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertAdvertisementBannersControls(i, 'order')" [isUpdate]="editMode" ></app-number>
              </td>
              <td class="col-md-2 mb-3" [formGroupName]="i"  style="height:50px">
                <app-check-box [fieldObject]="advertisementBanner['isHidden']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertAdvertisementBannersControls(i, 'isHidden')" [isUpdate]="editMode" ></app-check-box>
              </td>
            </div>
            </div>
            <div class="col-md-2">
            <td class="col-md-1 mt-3 text-center">
              <span class="removeItem text-danger" title="Delete" (click)="removeItems(i)"
                *ngIf="advertisementBanners.controls.length > 0">
                <i class="fa fa-trash" style="transform: scale(3);height:20px" title="Delete form field row"></i>
              </span>
            </td>
          </div>
          </tr>
        </tbody>
      </table>
      <button type="button" [disabled]='advertisementBanners.invalid' class="btn btn-success w-100 py-1 mx-0 "
        (click)="addAdvBannerGroup()">
        {{ 'Sellers.Products.AddItem' | translate }}
      </button>
      <div class="d-flex justify-content-end mt-2">
        <button class="btn btn-success col-auto" type="button" [disabled]="manageAdvertisementBannerForm.invalid" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
